import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import { Button } from './Button';
import './Navbar.css'

function Navbar() {
  const [click, setClick] = useState(false);

  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);

  const closeMobileMenu = () => {
    setClick(false) 
    window.scrollTo({top: 0,});
  }

  const showButton = () => {
    if(window.innerWidth > 960) {
      setButton(true);
    }
    else {
      setButton(false);
    }
  };

  useEffect(() => {showButton()}, []);

  window.addEventListener('resize', showButton);

  return (
    <>
    <nav className='navbar'>
      <div className='navbar-div'>
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            <figure className='rma__img__pic-wrap'>
              <img src='/images/RMA.png' alt='Img not found' className='rma-img'/>
            </figure>
          </Link>
      </div>
        <div className='navbar-container'>
            <div className='menu-icon' onClick={handleClick}>
              <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
            </div>
            <ul className={click ?  'nav-menu active' : 'nav-menu'}>
              <li className='nav-item'>
                <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                  Home
                </Link>
              </li>
              <li className='nav-item'>
                <Link to='/services' className='nav-links' onClick={closeMobileMenu}>
                  Services
                </Link>
              </li>
              <li className='nav-item'>
                <Link to='/calculator' className='nav-links' onClick={closeMobileMenu}>
                  Mortgage Calculator
                </Link>
              </li>
              <li className='nav-item'>
                <Link to='/meet-the-team' className='nav-links' onClick={closeMobileMenu}>
                  About Us
                </Link>
              </li>
              <li className='nav-item'>
                <Link to='/contact' className='nav-links' onClick={closeMobileMenu}>
                  Contact Us
                </Link>
              </li>
              <div className='nav-btn'>
                <Button buttonStyle='btn--outline' path={'/form'}>Apply Now!</Button>
              </div>
              
            </ul>
            {/* {button && <Button buttonStyle='btn--outline' path={'/contact'}>Contact Us</Button>} */}
            
        </div>
    </nav>
    </>
  )
}

export default Navbar